/* Sentry client init — graceful no-op when REACT_APP_SENTRY_DSN is empty.
 *
 * Called once from index.js before <App> mounts. When the operator later
 * pastes a Sentry DSN into frontend/.env and restarts, errors + unhandled
 * promise rejections get reported automatically with the release channel
 * (production / staging / preview) as the environment tag. */
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn || !dsn.trim()) return false;
  try {
    // Lazy require so unused code is tree-shaken when DSN is empty.
     
    const Sentry = require("@sentry/react");
    Sentry.init({
      dsn: dsn.trim(),
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.0,
      // Never send PII — the app handles sensitive immigration data.
      sendDefaultPii: false,
      // Strip URL query strings and cookies from breadcrumbs.
      beforeSend(event) {
        if (event.request) {
          delete event.request.cookies;
          if (event.request.url) {
            try {
              const u = new URL(event.request.url);
              u.search = "";
              event.request.url = u.toString();
            } catch (err) {
              console.warn("[Sentry] URL scrub failed:", err?.message || err);
            }
          }
        }
        return event;
      },
    });
    return true;
  } catch (err) {
    console.warn("[Sentry] init failed:", err?.message || err);
    return false;
  }
}
